import React from 'react';
import { useParams } from 'react-router-dom';
import { useRequest } from 'hooks';

import { Title } from 'components/Misc/Typography';
import { Form, Button } from 'components/Misc/Form';

const Recovery = () => {
	// Cache current user's id
	const { id } = useParams();

	// Store request
	const [[progress], request] = useRequest('put', `users/${id}`);

	// Handles form's onSubmit event
	// @event: object | onSubmit event
	const onSubmit = async event => {
		event.preventDefault();

		// Do not submit if request in progress
		if (progress) return;

		// Try to update user's data
		const [success, error] = await request(null, {
			related: 'recovery'
		});

		// Update user's data
		if (success) console.log(success);

		// TODO: Think of a better way of handling errors
		if (error) console.log(error);
	};

	return (
		<Form
			onSubmit={onSubmit}
			className="mt-4 p-4 space-y-4 bg-white dark:bg-neutral-800 rounded-lg transition-colors"
		>
			<Title
				title="Autorizācija"
				className="text-xl"
			/>

			<div className="text-neutral-800 dark:text-white transition-colors">
				Nosūtīt lietotājam autorizācijas atjaunošanas e-pastu.
			</div>

			<div className="flex justify-end">
				<Button
					submit
					icon="mail"
					value="Nosūtīt"
					theme="warning"
					progress={progress}
				/>
			</div>
		</Form>
	);
};

export default Recovery;
